import { useEffect, useState } from 'react';

export default function useDebounced<T>(value: T, delay: number) {
  const [isDebouncing, setIsDebouncing] = useState(false);
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(() => {
    setIsDebouncing(true);
    const timeout = setTimeout(() => {
      setDebouncedValue(value);
      setIsDebouncing(false);
    }, delay);
    return () => clearTimeout(timeout);
  }, [value, delay]);
  return [debouncedValue, isDebouncing] as [T, boolean];
}
